import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/Signup.css';
import SEOHelmet from './SEOHelmet';

const Signup = ({ onSignupSuccess }) => {
  const navigate = useNavigate();
  const [role, setRole] = useState('asset_incharge');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
     department: '' 
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRoleChange = (newRole) => {
    setRole(newRole);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.firstName.trim()) {
      setError('First name is required');
      return;
    }

    if (!formData.lastName.trim()) {
      setError('Last name is required');
      return;
    }

    if (!formData.email.trim()) {
      setError('Email is required');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email');
      return;
    }

    if (!formData.password) {
      setError('Password is required');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/signup`, {
        ...formData,
        role
      });

      if (response.data.success) {
        // All new users go to login page after signup
        // They need to authenticate and may need approval depending on role
        navigate('/login', { 
          state: { 
            message: 'Signup successful! Please login with your credentials.',
            email: formData.email 
          } 
        });
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Signup failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <SEOHelmet page="signup" canonicalUrl="https://www.assetflows.in/signup" />
      <div className="signup-card">
        <h1>Create Account</h1>
        
        <div className="role-selector">
          <label>Signup as:</label>
          <div className="role-buttons">

               <button
              type="button"
              className={`role-btn ${role === 'admin' ? 'active' : ''}`}
              onClick={() => handleRoleChange('admin')}
            >
               Admin
            </button>
            <button
              type="button"
              className={`role-btn ${role === 'asset_incharge' ? 'active' : ''}`}
              onClick={() => handleRoleChange('asset_incharge')}
            >
              Asset Incharge
            </button>
            <button
              type="button"
              className={`role-btn ${role === 'asset_technician' ? 'active' : ''}`}
              onClick={() => handleRoleChange('asset_technician')}
            >
              Asset Technician
            </button>
         
            <button
              type="button"
              className={`role-btn ${role === 'asset_user' ? 'active' : ''}`}
              onClick={() => handleRoleChange('asset_user')}
            >
              Asset User
            </button>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">First Name *</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Enter your first name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name *</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter your last name"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
            />
          </div>

{role === 'asset_user' && (
  <div className="form-group">
    <label htmlFor="department">Department *</label>
    <input
      type="text"
      id="department"
      name="department"
      value={formData.department}
      onChange={handleChange}
      placeholder="Enter your department"
    />
  </div>
)}

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="password">Password *</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password (min 6 characters)"
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password *</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm your password"
              />
            </div>
          </div>



          <button 
            type="submit" 
            className="submit-btn"
            disabled={loading}
          >
            {loading ? 'Creating Account...' : 'Sign Up'}
          </button>
        </form>

        <p className="login-link">
          Already have an account? <a href="/login">Login here</a>
        </p>
      </div>
    </div>
  );
};

export default Signup;
